import { createSlice } from '@reduxjs/toolkit';

const initialState: { user: User | undefined } = {
    user: {
        emailVerified: false,
        email: '',
        roles: [],
        username: '',
        groups: '',
        tenantKey: '',
        customerId: '',
        userId: '',
        firstName: '',
        lastName: '',
        landlordId: '',
        tableauToken: ''
    }
};

const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {
        setUser(state, action) {
            state.user = { ...state.user, ...action.payload };
        }
    }
});

export const { setUser } = configSlice.actions;

export default configSlice.reducer;
